module.exports = __webpack_public_path__ + "img/missed.8096ecc1.svg";